// MovAI Boards — login (solo Google). Firebase Auth MODULAR empaquetado por esbuild (self-host, sin CDN
// de gstatic — ADR-0004): firma con el popup de Google y canjea el ID token por la cookie de sesión.
// La config web de Firebase llega del server (/api/auth/config); sin ella, modo demo (botón inerte).
import { initializeApp } from 'firebase/app';
import type { FirebaseOptions } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { initConsent, track } from './consent.js';

interface AuthConfig {
  configured: boolean;
  firebase: FirebaseOptions | null;
}

const byId = (id: string): HTMLElement | null => document.getElementById(id);
const NEXT = new URLSearchParams(location.search).get('next') || '/dashboard';

function setStatus(msg: string, kind: 'info' | 'error' = 'info'): void {
  const el = byId('login-status');
  if (!el) return;
  el.textContent = msg;
  el.dataset.kind = kind;
}

async function exchangeAndRedirect(idToken: string): Promise<void> {
  setStatus('Entrando…');
  const res = await fetch('/api/auth/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken }),
  });
  if (!res.ok) {
    setStatus('No se pudo iniciar sesión. Intenta de nuevo.', 'error');
    return;
  }
  track('login', { method: 'google' }); // funnel (no-op sin GA/consentimiento)
  location.href = NEXT;
}

async function init(): Promise<void> {
  initConsent();
  const cfg: AuthConfig | null = await fetch('/api/auth/config')
    .then((r) => r.json() as Promise<AuthConfig>)
    .catch(() => null);
  if (!cfg?.configured || !cfg.firebase) {
    setStatus('Autenticación no configurada (modo demo).', 'error');
    return;
  }
  const auth = getAuth(initializeApp(cfg.firebase));

  byId('btn-google')?.addEventListener('click', async () => {
    try {
      const cred = await signInWithPopup(auth, new GoogleAuthProvider());
      await exchangeAndRedirect(await cred.user.getIdToken());
    } catch (e) {
      setStatus((e as { message?: string })?.message || 'Error de autenticación.', 'error');
    }
  });
}

void init();
